import React from 'react';
import { Clock } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const ExportComingSoon = ({ title }) => {
  const { t } = useTranslation();
  return (
    <div className="text-center py-5">
      <Clock size={48} className="text-muted mb-3" />
      <h5 className="text-muted">{title}</h5>
      <p className="text-muted mb-0">{t('shared.available_soon', 'This export will be available soon.')}</p>
    </div>
  );
};

export default ExportComingSoon;
